import type { IEntitiesStore } from 'entities/EntitiesExport'

export const checkAccessSuspendedPage = (entities: IEntitiesStore) => {
  const { subscriptionStore } = entities

  if (subscriptionStore.isActive || subscriptionStore.isTrial || subscriptionStore.isPastDue)
    return false

  // Agency accounts without a subscription are redirected to /clients, not /suspended.
  if (subscriptionStore.isAgencyWithoutSubscription) return false

  // Any non-agency user with an inactive subscription (owner or member) may view /suspended.
  return true
}
